import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import footerStyle from './Footer.module.scss';
import { BLANK } from '../../constants/constants';
import ClientConfig, { primarySocials } from '../../config';
import { profile } from '../../data/profile';
import { RoutesUrl } from '../../router/RouterUrls';

const navItems = [
    { route: RoutesUrl.home, key: 'header.home' },
    { route: RoutesUrl.about, key: 'header.about' },
    { route: RoutesUrl.projects, key: 'header.projects' },
    { route: RoutesUrl.contacts, key: 'header.contacts' },
];

const Footer = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const socialClickHandler = (url: string) => {
        window.open(url, BLANK, 'noopener,noreferrer');
    };

    return (
        <footer className={footerStyle.footer}>
            <div className={footerStyle.inner}>
                <div className={footerStyle.top}>
                    <div className={footerStyle.identity}>
                        <span className={footerStyle.monogram}>{profile.initials}</span>
                        <div>
                            <p className={footerStyle.name}>{t('footer.myName')}</p>
                            <p className={footerStyle.role}>
                                {profile.role} @ {profile.company}
                            </p>
                        </div>
                    </div>

                    <div className={footerStyle.columns}>
                        <div className={footerStyle.column}>
                            <h3 className={footerStyle.columnTitle}>{t('footer.navigate')}</h3>
                            {navItems.map((item) => (
                                <button key={item.route} type='button' className={footerStyle.link} onClick={() => navigate(item.route)}>
                                    {t(item.key)}
                                </button>
                            ))}
                        </div>

                        <div className={footerStyle.column}>
                            <h3 className={footerStyle.columnTitle}>{t('footer.reach')}</h3>
                            <a className={footerStyle.link} href={`mailto:${ClientConfig.email}`}>
                                {ClientConfig.email}
                            </a>
                            <a className={footerStyle.link} href={`tel:${ClientConfig.phoneNumber.replace(/-/g, '')}`}>
                                {ClientConfig.phoneNumber}
                            </a>
                            <span className={footerStyle.muted}>{t('footer.location')}</span>
                        </div>

                        <div className={footerStyle.column}>
                            <h3 className={footerStyle.columnTitle}>{t('footer.elsewhere')}</h3>
                            <div className={footerStyle.socials}>
                                {primarySocials.map((social, i) => (
                                    <button
                                        key={i}
                                        type='button'
                                        className={footerStyle.socialButton}
                                        onClick={() => socialClickHandler(social.url)}
                                        aria-label={social.label}
                                        title={social.label}
                                    >
                                        {React.cloneElement(social.icon, { className: footerStyle.socialIcon })}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className={footerStyle.bottom}>
                    <span className={footerStyle.copyright}>
                        © {new Date().getFullYear()} {profile.name}
                    </span>
                    <span className={footerStyle.builtWith}>{t('footer.builtWith')}</span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
